import { formatNumberCommaSeparated } from './numberFunctions';

export const formatDollars = (value?: number | null, absoluteValue = false, decimalPlaces = 2): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });

  if (value === null || value === undefined) {
    return formatter.format(+(0).toFixed(decimalPlaces));
  }

  // fix -0.00 to become 0.00 by adding 0
  value = +value.toFixed(decimalPlaces);
  value += 0;

  const displayValue = value < 0 && absoluteValue ? value * -1 : value;
  return formatter.format(displayValue);
};

export const formatAmountNoSymbol = (value?: number | null, absoluteValue = false, decimalPlaces = 2): string => {
  const dollarAmount = formatDollars(value, absoluteValue, decimalPlaces);
  return dollarAmount.replace('$', '');
};

export const negativeDollars = (value?: string | null) => {
  if (value && value?.includes('-')) {
    return `(${value.replace('-', '')})`;
  }
  return value;
};

export const xlNumFormat = (val: number | null | undefined = 0.0, digits = 2) => {
  return val ? negativeDollars(formatNumberCommaSeparated(val, digits)) : '0.00';
};

export const formatDollarsScaled = (value?: number | null): string => {
  let result = '$0.00';
  let scaledValue = 0;
  let suffix = '';
  if (value) {
    if (Math.abs(value) >= 1000000) {
      scaledValue = value / 1000000; //.toFixed(1);
      suffix = 'm';
    } else if (Math.abs(value) >= 1000) {
      scaledValue = value / 1000; //.toFixed(1);
      suffix = 'k';
    } else {
      scaledValue = value; //.toFixed(1);
    }

    result = formatDollars(scaledValue) + suffix;
  }

  return result;
};
